/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

interface EllipsisTextProps {
  text: React.ReactNode;
}

/**
 * Texte tronqué avec ellipsis si la colonne est trop étroite, avec le texte
 * complet dans l'attribut `title` (infobulle native au survol). À utiliser
 * dans une `ListeTable.Cell` dès que le contenu (registre, nom…) peut être
 * plus long que la largeur de colonne disponible : passer directement un
 * enfant texte à `ListeTable.Cell` lui applique déjà l'ellipsis (classe
 * `textEllipsis` automatique de `@mairistem/liste`), mais sans infobulle —
 * ce composant ajoute l'infobulle en conservant l'ellipsis.
 */
const EllipsisText = ({ text }: EllipsisTextProps) => (
  <span
    title={typeof text === 'string' ? text : undefined}
    style={{
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }}
  >
    {text}
  </span>
);

export default EllipsisText;
